import{createStyles as t}from"../../theme/utils/create-styles.js";var a=t({root:{"&.ant-input":{width:"auto"},"&.ant-input-affix-wrapper":{width:"auto"}}});export{a as styles};
